/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_No_Attempt_TitleInputs */

const en_player_no_attempt_title = /** @type {(inputs: Player_No_Attempt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No attempt in progress`)
};

const ja_player_no_attempt_title = /** @type {(inputs: Player_No_Attempt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`進行中の受験はありません`)
};

const fr_player_no_attempt_title = /** @type {(inputs: Player_No_Attempt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune tentative en cours`)
};

const de_player_no_attempt_title = /** @type {(inputs: Player_No_Attempt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein laufender Versuch`)
};

/**
* | output |
* | --- |
* | "No attempt in progress" |
*
* @param {Player_No_Attempt_TitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const player_no_attempt_title = /** @type {((inputs?: Player_No_Attempt_TitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_No_Attempt_TitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_player_no_attempt_title(inputs)
	if (locale === "ja") return ja_player_no_attempt_title(inputs)
	if (locale === "fr") return fr_player_no_attempt_title(inputs)
	return de_player_no_attempt_title(inputs)
});